export const PAYMENT_METHODS = ['PIX', 'CARTAO', 'DINHEIRO', 'TRANSFERENCIA'] as const;
export type PaymentMethod = (typeof PAYMENT_METHODS)[number];

export const PAYMENT_METHOD_LABELS: Record<PaymentMethod, string> = {
  PIX: 'PIX',
  CARTAO: 'Cartão',
  DINHEIRO: 'Dinheiro',
  TRANSFERENCIA: 'Transferência',
};

/** Situação de pagamento da OS (como no protótipo), agora calculada a partir dos lançamentos. */
export const PAYMENT_STATUSES = ['PENDENTE', 'PARCIAL', 'PAGO'] as const;
export type PaymentStatus = (typeof PAYMENT_STATUSES)[number];

export const PAYMENT_STATUS_LABELS: Record<PaymentStatus, string> = {
  PENDENTE: 'Pendente',
  PARCIAL: 'Parcial',
  PAGO: 'Pago',
};

/** OS sem valor a cobrar (garantia, retorno, cortesia…): não faz sentido mostrar "Pendente". */
export const NO_CHARGE_LABEL = 'Sem cobrança';
export const isNoCharge = (total: number, status: PaymentStatus, orderStatus?: string) =>
  orderStatus === 'NAO_APROVADO' || orderStatus === 'SEM_REPARO' || (total <= 0 && status === 'PENDENTE');
export const paymentStatusLabel = (status: PaymentStatus, total: number, orderStatus?: string) =>
  isNoCharge(total, status, orderStatus) ? NO_CHARGE_LABEL : PAYMENT_STATUS_LABELS[status];

/** Situação de cada lançamento: estornos ficam registrados em vez de apagados. */
export const PAYMENT_ENTRY_STATUSES = ['CONFIRMED', 'REFUNDED'] as const;
export type PaymentEntryStatus = (typeof PAYMENT_ENTRY_STATUSES)[number];

export function derivePaymentStatus(totalCents: number, paidCents: number): PaymentStatus {
  if (paidCents <= 0) return 'PENDENTE';
  if (paidCents >= totalCents) return 'PAGO';
  return 'PARCIAL';
}
